require('./bootstrap')

// Import function
import Vue from 'vue'
import Toasted from 'vue-toasted'
import testimonials from './data/testimonials'
import homeFaqs from './data/home-faqs'
import PhoneLink from './components/PhoneLink'
import store from './store'

import ActionCard from './components/ActionCard'
Vue.component('action-card', ActionCard)

Vue.use(Toasted)

import 'es6-promise/auto'

var standalone = window.navigator.standalone,
    userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test( userAgent ),
    ios = /iphone|ipod|ipad/.test( userAgent );

    let mobileWidth = 900

const app = new Vue({
    el: '#app',
    components: {
        PhoneLink
    },
    store,
    data: {
        animationIndex: 0,
        mobileWallVisible: false,
        activeFaqSection: 'about',
        testimonials,
        homeFaqs,
        notifications: [],
        dealerModalVisible: false,
        slideout: {
            open: false
        },
        timer: 0,
    },
    computed: {
        currentAnimation() {
            let keys = Object.keys(this.animationLinks)
            let currentIndex = this.animationIndex
            let key = keys[currentIndex]
            return this.animationLinks[key]
        },

        activeTestimonial() {
            return this.testimonials.filter(t => t.active)[0]
        },

        nextAnimation() {
            let keys = Object.keys(this.animationLinks)
            let next = this.animationIndex + 1
            let key = keys[next]
            return this.animationLinks[key]
        }
    },
    methods: {
        showNotification(title, text, icon) {
            let notification = { title, text, icon }
            this.notifications.unshift(notification)
            window.setTimeout(() => {
                let notificationCount = this.notifications.length
                let lastIndex = notificationCount - 1
                let newAlerts = this.notifications.splice(lastIndex, 1)
            }, 6000)
        },

        play() {
            let video = this.$refs.animation
            if (video.currentTime > 0 && !video.ended) {
                return
            }
            video.play()
            let n = this.showNotification
            // Door opened
            window.setTimeout(
                () => n('Door opened', 'Front door opened', 'door-opened.png'),
                2000
            )
            // Dad arms system
            window.setTimeout(
                () => n('System Armed', 'Armed by Dad', 'system-armed.png'),
                6500
            )
            // Mailman steps onto porch
            window.setTimeout(
                () =>
                    n(
                        'Video from front door',
                        'Video from front door bell camera',
                        'video-front-door.png'
                    ),
                19500
            )
            // Glass breaks
            window.setTimeout(
                () =>
                    n(
                        'Window broken',
                        'Living room window broken',
                        'window-broken.png'
                    ),
                32500
            )
            // Burglar pulls window up
            window.setTimeout(
                () =>
                    n(
                        'Alarm activated',
                        'Living room window opened',
                        'alarm-activated.png'
                    ),
                52000
            )
            // Smoke starts
            window.setTimeout(
                () =>
                    n(
                        'Living room fire',
                        'Contacting fire department',
                        'living-room-fire.png'
                    ),
                56000
            )
            // Snow starts falling
            window.setTimeout(
                () =>
                    n(
                        'Temperature dropping',
                        'Adjusting temperature',
                        'temperature-dropping.png'
                    ),
                75000
            )
        },

        toggleFaq(index) {
            this.homeFaqs[index].visible = !this.homeFaqs[index].visible
        },

        showTestimonial(id) {
            let ts = [...this.testimonials]
            this.testimonials = ts.map(t => {
                t.active = t.id === id
                return t
            })
        },

        hideMobileWall() {
            this.mobileWallVisible = false
            mixpanel.track('mobile_finishedLanding')
            this.play()
        },

        setAnimationPosition() {
            let containerWidth = 1200
            let mobileBreakpoint = 900
            let viewportWidth = window.innerWidth
            let animationsEl = this.$refs.animations
            let contentWithAnimationEl = this.$refs.contentWithAnimation
            let leftFromContainer = 330

            if (
                viewportWidth > containerWidth &&
                viewportWidth > mobileBreakpoint
            ) {
                let widthToContainer = contentWithAnimationEl.offsetLeft
                let fullLeft = widthToContainer + leftFromContainer
                animationsEl.style.left = `${fullLeft}px`
            }

            if (
                viewportWidth < containerWidth &&
                viewportWidth > mobileBreakpoint
            ) {
                let offset = viewportWidth - containerWidth
                let fullLeft = offset + leftFromContainer
                animationsEl.style.left = `${fullLeft}px`
            }

            // let videoOffset = animationsEl.offsetTop
            // let pageOffset = window.pageYOffset
            // if (pageOffset > videoOffset) {
            //     let offset = pageOffset.toFixed(2)
            //     animationsEl.style.transform = `translate3d(260px, ${offset}px, 0)`
            // } else {
            //     animationsEl.classList = 'animations'
            // }
        },

        scrollToAnchor(id) {
            let el = document.getElementById(id)
            let offset = el.offsetTop
            window.scroll({
                top: offset,
                left: 0,
                behavior: 'smooth'
            })
        },

        toggleSlideout() {
            this.slideout.open = !this.slideout.open
        },

        closeSlideout() {
            this.slideout.open = false
        },

        showDealerModal() {
            this.dealerModalVisible = true
        },

        hideDealerModal() {
            this.dealerModalVisible = false
        },

        startTimer() {
            setInterval(() => this.timer += 1, 1000)
        },

        goToAssessment(location, event) {
            event.preventDefault()
            let timerData = {
                location
            }
            // mixpanel.track("startedApp", timerData)
            mixpanel.people.set(timerData)
            window.location = '/assessment'
        }
    },
    mounted() {
        // HOMEPAGE
        if (window.location.pathname === '/') {
            let animationsEl = this.$refs.animations
            animationsEl.style.opacity = '1'
            this.$refs.animation.addEventListener('loadeddata', () => {
                console.log('loaded')
                this.play()
            })
            // window.onresize = () => this.setAnimationPosition()
            this.$refs.animation.addEventListener('ended', () => {
                this.play()
            })
            this.startTimer()
        }

        // FAQ Page
        if (window.location.pathname.includes('faq')) {
            let section = document.querySelectorAll('.faqSection')
            let sections = {}
            let i = 0
            let that = this

            Array.prototype.forEach.call(section, function(e) {
                sections[e.id] = e.offsetTop
            })

            window.onscroll = function() {
                var scrollPosition =
                    document.documentElement.scrollTop ||
                    document.body.scrollTop

                for (i in sections) {
                    if (sections[i] <= scrollPosition) {
                        that.activeFaqSection = i
                    }
                }
            }
        }
    }
})

window.app = app

// burglar, dad, mail, snow, window smash, fire
